import { useCallback, useState, useEffect } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Button, List, ListItem, ListItemButton } from "@mui/material";
import { uploadFileThunk } from "../../../../../components/general/generalThunk";
import { useDispatch } from "react-redux";
import SnackbarMessage from "../../../../../components/snackBar/snackBar";
import NodeDeleteButton from "./nodeDeleteButton";


function CustomNode2({ id, isConnectable, data }) {
  const dispatch = useDispatch();
  const { setNodes } = useReactFlow();
  const [url, setUrl] = useState("");
  const [fileType, setFileType] = useState("image");
  const [showHeader, setShowHeader] = useState(false);
  const [showFooter, setShowFooter] = useState(false);
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);

  const [nodeId, setNodeId] = useState(id);
  const [state, setState] = useState({
    header: "",
    // footer: "",
    url: url,
    message: "",
    buttons: [
      {
        id: 1,
        value: "",
      },
    ],
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (data !== undefined && data.state) {
      // Normalize buttons - convert backend's 'title' to 'value' for component use
      let normalizedButtons = data.state.buttons;
      if (normalizedButtons && Array.isArray(normalizedButtons)) {
        normalizedButtons = normalizedButtons.map(button => ({
          ...button,
          value: button.value || button.title || "", // Use title if value doesn't exist
          title: button.title || button.value || "", // Preserve title if it exists
        }));
      }
      
      // Set state with normalized buttons
      setState({
        ...data.state,
        buttons: normalizedButtons || data.state.buttons,
      });
      
      // Set URL if it exists
      if (data.state.url) {
        setUrl(data.state.url);
      }
    }
  }, [data]);


  const { deleteElements } = useReactFlow();

  const handleDeleteNode = useCallback(() => {
    deleteElements({ nodes: [{ id }] });
  }, [id, deleteElements]);

  const [isHover, setIsHover] = useState(false);

  // const handleSaveState = useCallback(() => {
  //   dispatch(saveEntireState(state));
  // }, [dispatch, state]);

  // useEffect(() => {
  //   handleSaveState();
  // }, [state]);

  const handleNodeFocus = () => {
    setState((prevState) => ({
      ...prevState,
      isNodeClicked: true,
    }));
  };


  const handleChange = async (e, index) => {
    // console.log(getNodesBounds);
    const value = e.target.value;
    const name = e.target.name;
    // console.log(value, name, index);
    // debugger;
    if (name === "url") {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        const reader = new FileReader();
        reader.onloadend = async () => {
          const chatBotImage = reader.result;

          // axios.post("https://wapi.rizee.in/file-upload", {
          //   "category": "chatbot",
          //   "file": chatBotImage,
          //   "client_id": localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).client_id : ""
          // })
          //   .then(response => {
          //     // console.log("response1111", response.data);
          //     setUrl(response.data.destinationPath);

          //     setState((prevState) => ({
          //       ...prevState,
          //       [name]: response.data.destinationPath,
          //     }));

          //     setNodes((nodes) =>
          //       nodes.map((node) => {
          //         if (node.id === id) {
          //           return {
          //             ...node,
          //             data: {
          //               ...node.data,
          //               state: {
          //                 ...node.data.state,
          //                 [name]: response.data.destinationPath,
          //               },
          //             },
          //           };
          //         }
          //         return node;
          //       })
          //     );
          //   })
          //   .catch(error => {
          //     console.error("Error", error);
          //   });

          const file = [{ filename: selectedFile.name, img: chatBotImage }];

          try {
            const uploadResult = await dispatch(
              uploadFileThunk({ credentials: { file, category: "userImages" } })
            );

            if (
              uploadResult.meta.requestStatus !== "fulfilled" ||
              !uploadResult.payload?.data?.length
            ) {
              return setSnackbar({
                open: true,
                message: uploadResult.payload?.message || "File upload failed",
                severity: "error",
              });
            }

            const uploadedFileData = uploadResult.payload.data[0];
            const uploadedPath = uploadedFileData.file_url;
            console.log("uploadedPath", uploadResult);
            setUrl(uploadedFileData);

            // Update nodes with the uploaded file data (full object) FIRST
            setNodes((nodes) =>
              nodes.map((node) => {
                if (node.id === id) {
                  return {
                    ...node,
                    data: {
                      ...node.data,
                      state: {
                        ...node.data?.state,
                        [name]: uploadedFileData,
                      },
                    },
                  };
                }
                return node;
              })
            );

            // Update state with the uploaded file data (full object) AFTER nodes are updated
            setState((prevState) => ({
              ...prevState,
              [name]: uploadedFileData,
            }));

            const isSuccess = uploadResult.meta.requestStatus === "fulfilled";

            setSnackbar({
              open: true,
              message: isSuccess
                ? uploadResult.payload.message
                : uploadResult.payload || "File creation failed",
              severity: isSuccess ? "success" : "error",
            });

          } catch {
            setSnackbar({
              open: true,
              message: "Server error. Please try again.",
              severity: "error",
            });
          }
        };
        reader.readAsDataURL(selectedFile);
      }
    } else {
      if (index !== undefined) {
        // debugger;
        setState((prevState) => {
          const newState = { ...prevState };
          if (name === "buttons") {
            newState.buttons = prevState.buttons.map((button, i) => 
              i === index ? { ...button, value: value, title: value } : button // Keep title and value in sync
            );
          }
          
          // Update nodes with the new state immediately
          setNodes((nodes) =>
            nodes.map((node) => {
              if (node.id === nodeId) {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    state: {
                      ...node.data?.state,
                      buttons: newState.buttons,
                    },
                  },
                };
              }
              return node;
            })
          );
          
          return newState;
        });
      } else {
        setState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        setNodes((nodes) =>
          nodes.map((node) => {
            if (node.id === id) {
              if (node.data !== undefined) {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    state: {
                      ...node.data?.state,
                      [name]: value,
                    },
                  },
                };
              } else {
                return {
                  ...node,
                  data: {
                    label: "Buttons node",
                    state: {
                      header: "",
                      footer: "",
                      url: url,
                      message: value,
                      buttons: [
                        {
                          id: 1,
                          value: "",
                        },
                      ],
                    },
                  },
                };
              }
            }
            return node;
          })
        );
      }
    }
  };

  const addButton = () => {
    const newState = { ...state };
    if (newState.buttons && newState.buttons.length > 0) {
      const newButton = {
        id: newState.buttons.length + 1,
        value: "",
        title: "", // Keep title for backend compatibility
      };
      newState.buttons = [...newState.buttons, newButton];
    } else {
      newState.buttons = [
        {
          id: 1,
          value: "",
          title: "", // Keep title for backend compatibility
        },
      ];
    }
    setState(newState);
    
    // Update nodes with the new buttons
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              state: {
                ...node.data?.state,
                buttons: newState.buttons,
              },
            },
          };
        }
        return node;
      })
    );
  };

  const handleStyle = {
    background: "#B7D0F0",
    width: "6px",
    height: "6px",
    borderRadius: "60%",
  };

  const setFileFunction = (type) => {
    setFileType(type)
    if (type === "text") {
      setShowHeader(true)
      setUrl("")
    } else if (type === "image") {
      setShowHeader(false)
      // Don't clear url when selecting image
    } else {
      setShowHeader(false)
    }
  }




  const deleteButton = () => {


    if (state && state.buttons && state.buttons.length > 1) {
      const result = state.buttons.slice(0, -1);

      setState((prevState) => ({
        ...prevState,
        buttons: result
      }));


      // Update the nodes with the new state
      setNodes((nodes) =>
        nodes.map((node) => {
          if (node.id === nodeId) {
            return {
              ...node,
              data: {
                ...node.data,
                state: {
                  ...node.data?.state,
                  buttons: result, // Update only the buttons property
                },
              },
            };
          }
          return node;
        })
      );
    }
  };


  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className="container"
    >
      {/* delete step (round button + confirmation) */}
      <NodeDeleteButton visible={isHover} onDelete={handleDeleteNode} />
      <div
        className="text-updater-node overflow-auto pb-3"
        onClick={handleNodeFocus}
      >
        {/* <div style={{ marginTop: "5px" }}>Send Message</div> */}

        <div
          style={{ padding: "5px" }}
          className="d-flex flex-row items-center justify-center"
        >
          <WhatsAppIcon
            style={{
              fontSize: "20px",
              color: "#22D954",
              borderRadius: "5px",
              padding: "2px",
              marginTop: "5px",
              backgroundColor: "#fff",
              boxShadow: "0px 0px 2px 0.5px rgba(0, 0, 0, 0.5)",
            }}
          />
          <b className="m-1">Buttons Layout</b>
        </div>
        <div
          style={{ marginTop: "5px", width: "100%" }}
          className="d-flex flex-row justify-content-between content-center"
        ></div>
        {showHeader && (
          <div className="sub_header d-flex flex-column">
            <div className=" d-flex flex-row  justify-content-between align-center">
              <b className="align-self-center">Header</b>
            </div>

            <div
              style={{
                border: "1px solid #e7e7e7",
                position: "relative",
                borderRadius: "5px",
                fontSize: "9px",
                padding: "3px",
                display: "flex",
              }}
            >
              <input
                type="text"
                name="header"
                value={state && state.header ? state.header : ""}
                style={{
                  border: "none",
                  padding: "5px",
                  width: "100%",
                  outline: "none",
                }}
                onChange={(e) => handleChange(e)}
              />

            </div>
            <span style={{ color: "red" }}>{state.header.length > 20 ? "Header length should be lessthan 20 char" : ""}</span>
          </div>
        )}

        <div className="">
          <div
            style={{
              paddingBottom: "5px",
            }}
          >
            {/* {url ? (
              <img
                src={url}
                alt="Uploaded Image"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            ) : (
              ""
            )} */}
            {url && url?.file_extension_type && url.file_extension_type.includes("video") ? (
              <video controls style={{ maxWidth: "100%", maxHeight: "100%" }}>
                <source src={url.file_url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : url && url?.file_extension_type && url.file_extension_type.includes("pdf") ? (
              // You can use react-pdf or another library to render PDFs
              <div><b>PDF Selected</b></div>
            ) : url ? (
              <img
              src={url?.file_url ?? url}
                alt="Uploaded Image"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            ) : null}
          </div>
        </div>

        <div className="sub_header">
          {/* <div
            style={{
              marginBottom: "5px",
              paddingBottom: "5px",
              borderBottom: "1px solid #e7e7e7",
              width: "100%",
            }}
            className="d-flex flex-row justify-content-between"
          >
            <span>
              <b>Body</b>
            </span>
            <span>
              <a href="#" onClick={() => setShowHeader(true)}>
                Add Header
              </a>
            </span>{" "}
            <span>
              <a href="#" onClick={() => setShowFooter(true)}>
                Add Footer
              </a>
            </span>
          </div> */}
          <div
            style={{
              marginBottom: "5px",
              paddingBottom: "5px",
              borderBottom: "1px solid #e7e7e7",
              width: "100%",
              position: "relative",
            }}
            className="d-flex flex-row justify-content-between"
          >
            <span>
              <b>Body</b>
            </span>
            <span>
              <a href="#" onClick={() => setShowHeaderOptions(true)}>
                Add Header
              </a>
              {showHeaderOptions && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    marginTop: "5px",
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.5)",
                    zIndex: 999,
                  }}
                  onMouseLeave={() => setShowHeaderOptions(false)}
                >
                  <List>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => { setFileFunction("text") }}>
                        Text
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => { setFileFunction("image"); }}>
                        Image
                        <input
                          id="upload-input"
                          type="file"
                          accept="image/png,image/jpg,image/jpeg,image/PNG,image/JPG,image/JPEG,.png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
                          name="url"
                          onChange={handleChange}
                          style={{

                            marginLeft: "-40px",
                            top: "0",

                            width: "40px",

                            opacity: "0",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => setFileFunction("dodument")}>
                        Document
                        <input
                          id="upload-input"
                          type="file"
                          accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.pdf,.doc,.docx,.xls,.xlsx,.PDF,.DOC,.DOCX,.XLS,.XLSX"
                          name="url"
                          onChange={handleChange}
                          style={{
                            // position: "absolute",
                            marginLeft: "-40px",
                            top: "0",

                            width: "40px",
                            // height: "100%",
                            opacity: "0",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => setFileFunction("video")}>
                        Video
                        <input
                          id="upload-input"
                          type="file"
                          accept="audio/mpeg,video/mp4,audio/mp3,audio/MP3,video/MP4,audio/MPEG,.mp3,.mp4,.MP3,.MP4"
                          name="url"
                          onChange={handleChange}
                          style={{
                            // position: "absolute",
                            marginLeft: "-40px",
                            top: "0",

                            width: "40px",
                            // height: "100%",
                            opacity: "0",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </div>
              )}
            </span>{" "}
            {/* <span>
              <a href="#" >
                Add Footer
              </a>
            </span> */}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <textarea
              type="text"
              name="message"
              value={state ? state.message : ""}
              onChange={(e) => handleChange(e)}
              style={{
                border: "1px solid #e7e7e7",
                borderRadius: "5px",
                padding: "5px",
                outline: "none",
                height: 50,

                resize: "none",
              }}
            />
            {state &&
              state.buttons !== undefined &&
              state.buttons.length > 0 ? (
              <>
                <span>
                  <b>Buttons</b>
                </span>
                {state.buttons.map((item, index) => (
                  <>
                    <div>Button {index + 1}</div>
                    <div
                      style={{
                        border: "1px solid #e7e7e7",
                        position: "relative",
                        borderRadius: "5px",
                        fontSize: "9px",
                        padding: "3px",
                        display: "flex",
                      }}
                    >
                      <input
                        type="text"
                        name="buttons"
                        value={item ? item.value : ""}
                        style={{
                          border: "none",
                          padding: "5px",
                          width: "100%",
                          outline: "none",
                        }}
                        onChange={(e) => { handleChange(e, index) }}
                      />
                      <Handle
                        type="source"
                        position={Position.Right}
                        id={`bc-${index}-ds`}
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                        isConnectable={isConnectable}
                      />
                    </div>
                    <span style={{ color: "red" }}>{item.value.length > 20 ? "Buttons length should be lessthan 20 char" : ""}</span>
                  </>
                ))}
                <div className="d-flex flex-row justify-content-between p-1">
                  <Button
                    style={{

                      color: state.buttons.length < 3 ? "none" : "red",

                    }}
                    type="button"
                    onClick={deleteButton}
                    disabled={state.buttons.length < 2}
                  >
                    Delete
                  </Button>
                  <Button

                    type="button"
                    onClick={addButton}
                    disabled={state.buttons.length === 3}
                  >
                    Add
                  </Button>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        {showFooter && (
          <div className="sub_header d-flex flex-column">
            <b>Footer</b>
            <div
              style={{
                border: "1px solid #e7e7e7",
                position: "relative",
                borderRadius: "5px",
                fontSize: "9px",
                padding: "3px",
                display: "flex",
              }}
            >
              <input
                type="text"
                name="footer"
                value={state && state.footer ? state.footer : ""}
                style={{
                  border: "none",
                  padding: "5px",
                  width: "100%",
                  outline: "none",
                }}
                onChange={(e) => handleChange(e)}
              />
            </div>
          </div>
        )}
        <Handle
          type="target"
          position={Position.Top}
          id="d"
          style={{
            background: "#ADADAD",
            width: "8px",
            height: "8px",
            borderRadius: "60%",
            left: 10,
          }}
          isConnectable={isConnectable}
        />

        <div
          style={{
            position: "absolute",
            bottom: 10,
            right: 10,
            width: "8px",
            height: "8px",
            borderRadius: "60%",
          }}
        >
          <Handle
            type="source"
            position={Position.Bottom}
            id="e"
            style={handleStyle}
            isConnectable={isConnectable}
          />
        </div>

        <SnackbarMessage
          open={snackbar.open}
          message={snackbar.message}
          severity={snackbar.severity}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        />
      </div>
    </div>
  );
}

export default CustomNode2;
